export default class PollFormModule {
  /**
   * @param {Element} element
   */
  constructor (element) {
    this.element = element;
    this.init();
    this.registerEvents();
  }

  init () {
    this.form = this.element.querySelector('form');
    this.submit = this.element.querySelector('[type="submit"]');
  }

  handleInput () {
    const checked = !!this.element.querySelector('[type="radio"]:checked');
    if (checked) this.submit.disabled = false;
  }

  handleSubmit (event) {
    event.preventDefault();
    this.element.classList.add('is-loading');

    const formData = new FormData(this.form);
    const data = {
      security: window.DGFM.ajaxNonce,
      form_data: Object.fromEntries(formData.entries()),
    };

    // Submit vote
    fetch(window.DGFM.ajaxUrl + '?action=dgfm/poll_submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const text = await response.text();
        let payload = {};
        try {
          payload = JSON.parse(text);
        } catch (e) {
          console.error('Unexpected response:', text);
        }

        if (!payload?.success) {
          this.element.classList.remove('is-loading');
          alert(payload?.data?.message || 'Fehler beim Absenden.');
          return;
        }

        // Reload the page so every poll block (form, alert, result charts) shows fresh data.
        // Keep the loading state until the browser navigates.
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        this.element.classList.remove('is-loading');
        alert('Netzwerkfehler.');
      });
  }

  registerEvents () {
    this.element.addEventListener('input', this.handleInput.bind(this));
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }
}